import { captureAndActivate, deactivateOnlyElement } from 'OK/capture';
import { getIcon } from 'OK/LazyIconNative';
import { firstByClass, querySelector } from 'OK/utils/dom';
import dot from 'dot';
import tplTxt from 'text!OK/NonBlockingTip.dot';

var tpl;
var tipHovered = false;
var shortcutMenuTipSelector = '.js-tip-shortcut-menu';
var shortcutMenuTipClassModificator = 'tip-shortcut-menu';


// Отображение названий опций в CSS-классы
var classMap = {
    fixed: '__fixed',
    mid: '__mid',
    large: '__l',
    anim: '__anim',
    close: '__close',
    bot: '__bot',
    toast: '__toast',
    action: '__action-tip'
};
var defaults = {
    fixed: true,
    mid: true,
    large: true,
    anim: true,
    close: false,
    bot: false,
    toast: false,
    action: false,
    message: '',
    visibleTime: 2000,
    holder: document.body
};

export default class NonBlockingTip {
    static existingTips = {};

    constructor() {
        this.container = null;
        this.shortcutMenuElement = null;
        this.shortcutMenuObserver = null;
        this.mouseenter = this.mouseenter.bind(this);
        this.mouseleave = this.mouseleave.bind(this);
        this.cancelCloseTipAction = this.cancelCloseTipAction.bind(this);
        this.observeShortcutMenuContainer = this.observeShortcutMenuContainer.bind(this);
    }

    mouseenter() {
        tipHovered = true;
        clearTimeout(this.timeoutId.fun);
    }

    mouseleave() {
        tipHovered = false;
        var that = this;
        this.timeoutId.fun = setTimeout(function () {
            that.closeTip(that.timeoutId.resolve);
        }, 1000);
    }

    cancelCloseTipAction() {
        clearTimeout(this.timeoutId.fun);
    }

    handleShortcutMenuClosed() {
        if (tipHovered) {
            return;
        }

        var that = this;
        this.timeoutId.fun = setTimeout(function () {
            that.closeTip(that.timeoutId.resolve);
        }, 1000);
    }

    observeShortcutMenuContainer(mutationsList, observer) {
        var shortcutMenuBlock = null;
        var childListMutation = null;

        for (var i = 0; i < mutationsList.length; i++) {
            var mutation = mutationsList[i];

            if (mutation.type === 'childList') {
                childListMutation = mutation;
                break;
            }
        }

        if (!childListMutation) {
            return;
        }

        for (var j = 0; j < childListMutation.addedNodes.length; j++) {
            var addedNode = childListMutation.addedNodes[j];
            var shortcutMenuElement = addedNode.querySelector(shortcutMenuTipSelector);
            if (shortcutMenuElement) {
                shortcutMenuBlock = addedNode;
                break;
            }
        }

        if (shortcutMenuBlock) {
            shortcutMenuBlock.classList.add(shortcutMenuTipClassModificator);
        } else {
            this.handleShortcutMenuClosed();
        }
    }

    activate(element) {
        this.container = element;

        this.tipUrl = firstByClass(element, "js-tip-block-url");
        var me = this;
        if (this.tipUrl) {
            this.clickListener = function () {
                me.container.classList.add('invisible');
            };
            this.tipUrl.addEventListener("click", this.clickListener);
        }

        if (element.getAttribute('data-show-on-hover')) {
            this.showOnHover = true;
            element.addEventListener('mouseenter', this.mouseenter);
            element.addEventListener('mouseleave', this.mouseleave);

            if (element.getAttribute('data-listen-shortcut-menu')) {
                this.shortcutMenuElement = document.querySelector('#hook_Block_ShortcutMenu');

                if (this.shortcutMenuElement) {
                    this.listenShortcutMenu = true;
                    this.shortcutMenuObserver = new MutationObserver(this.observeShortcutMenuContainer);
                    this.shortcutMenuObserver.observe(this.shortcutMenuElement, {childList: true});
                    this.shortcutMenuElement.addEventListener('mouseenter', this.cancelCloseTipAction);
                }
            }
        }

        if (element.id) {
            NonBlockingTip.existingTips[element.id] = this;
        }
        if (element.getAttribute("data-show")) {
            this.show();
        }

        var hideItem = element.getAttribute('data-hide-item');
        if (hideItem) {
            hideItem = querySelector(element, hideItem);
            if (hideItem) {
                this.hideItem = hideItem;
                this.onHideItemClick = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (me.container) {
                        me.closeTip();
                    }
                };
                hideItem.addEventListener('click', this.onHideItemClick);
            }
        }
    }

    show() {
        if (this.container && this.container.querySelector('.tip_cnt').childNodes.length > 0) {

            // Через сколько миллисекунд скрыть tip уведомление
            var visibleTimeStr = this.container.getAttribute('data-visible-time');
            if (visibleTimeStr) {
                var visibleTime = parseInt(visibleTimeStr, 10);
                this.showAndCloseWithTimeout(visibleTime);
            } else {
                this.container.offsetWidth;
                this.setShowClass();
            }
        }
    }

    setShowClass() {
        var classList = this.container.classList;
        classList.remove('__hidden');
        classList.add('__active');
    }

    setHideClass() {
        var classList = this.container.classList;
        classList.remove('__active');
        classList.add('__hidden');
    }

    showAndCloseWithTimeout(visibleTime) {
        var that = this;

        return new Promise(function (resolve) {
            that.container.offsetWidth;
            that.setShowClass();
            that.timeoutId = {
                resolve: resolve,
                fun: setTimeout(function () {
                    that.closeTip(resolve);
                }, visibleTime)
            };
        });
    }

    closeTip(resolve) {
        this.setHideClass();
        deactivateOnlyElement(this.container);

        if (resolve) {
            resolve();
        }
    }

    deactivate() {
        var container = this.container;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId.fun);
        }

        if (this.tipUrl) {
            this.tipUrl.removeEventListener("click", this.clickListener);
        }
        if (this.hideItem) {
            this.hideItem.removeEventListener('click', this.onHideItemClick);
        }
        if (container) {
            if (this.showOnHover) {
                container.removeEventListener('mouseenter', this.mouseenter);
                container.removeEventListener('mouseleave', this.mouseleave);
            }
            if (container.id) {
                NonBlockingTip.existingTips[container.id] = null;
            }
            this.container = null;

            if (this.shortcutMenuElement && this.listenShortcutMenu) {
                this.shortcutMenuElement.removeEventListener('mouseenter', this.cancelCloseTipAction);

                if (this.shortcutMenuObserver) {
                    this.shortcutMenuObserver.disconnect();
                }
            }
        }
    }

    /**
     * Формирует CSS-классы для уведомления на основе заданных опций.
     * Если CSS-классы уже заданы в опции `tipClass`, то возвращается значение этой опции.
     *
     * @param {object} options
     *      Опции, на основе которых формируются CSS-классы.
     * @param {boolean} [addOption=false]
     *      Надо ли добавить опцию `tipClass` со сформированными классами в переданный объект `options`.
     * @return {string}
     *      CSS-классы, заданные в поле `options.tipClass`, или сформированные, если значение поля не задано.
     */
    static formTipClass(options, addOption) {
        var tipClass = options.tipClass;

        if (!tipClass) {
            tipClass = [];
            for (var key in classMap) {
                if (classMap.hasOwnProperty(key) && options[key]) {
                    tipClass.push(classMap[key]);
                }
            }
            tipClass = tipClass.join(' ');
            if (addOption) {
                options.tipClass = tipClass;
            }
        }

        return tipClass;
    }

    static create(opts) {
        if (typeof opts === 'string') {
            opts = {
                message: opts
            };
        }
        var options = Object.assign({}, defaults, opts);
        NonBlockingTip.formTipClass(options, true);

        var close = options.close || hasClass(options.tipClass, classMap.close);
        if (close) {
            options.close = getIcon('ico_close_16');
        }

        // создали шаблон, если надо
        if (!tpl) {
            tpl = dot.template(tplTxt);
        }

        // создаем element tip
        var wrap = document.createElement('div');
        wrap.innerHTML = tpl(options);
        var el = firstByClass(wrap, 'tip');
        if (options.tsId) {
            el.setAttribute('tsid', options.tsId);
        }

        options.holder.appendChild(wrap);

        captureAndActivate('body', el);

        // создаем NonBlockingTip
        var tip = new NonBlockingTip();
        tip.activate(el);

        function destroy() {
            deactivateOnlyElement(el);
            tip.deactivate();
            options.holder.removeChild(wrap);
        }

        return tip.showAndCloseWithTimeout(options.visibleTime)
            .then(function () {
                // убили после показа
                if (options.anim) {
                    setTimeout(destroy, 150); // анимация скрытия 150мс
                } else {
                    destroy();
                }
            });
    }
}


/**
 * Проверяет наличие CSS-класса в указанной строке.
 *
 * @param {string} classNames
 *      Строка с названиями классов, в которой надо проверить наличие класса.
 * @param {string} targetClass
 *       CSS-класс, наличие которого надо проверить.
 * @return {boolean}
 *      `true`, если проверяемый класс есть в строке.
 * @ignore
 */
function hasClass(classNames, targetClass) {
    return !!classNames && classNames.split(' ').includes(targetClass);
}

var existingTips = NonBlockingTip.existingTips;
var formTipClass = NonBlockingTip.formTipClass;
var create = NonBlockingTip.create;
export { existingTips, formTipClass, create };
